import { call, select } from 'redux-saga/effects';

import * as $auth from 'modules/auth';
import * as api from '../api';

export const updateArtset = function* (artset) {
  const token = yield select($auth.getToken);
  const publisherId = yield select($auth.getSelectedPublisherId);
  yield call(api.updateArtset, artset, {
    token,
    publisherId,
  });
};
